// src/pages/HomePage.js
import HeroSection from '../components/sections/HeroSection';
import AboutSection from '../components/sections/AboutSection';
import PortfolioSection from '../components/sections/PortfolioSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import BlogSection from '../components/sections/BlogSection';
import FAQSection from '../components/sections/FAQSection';
import ContactSection from '../components/sections/ContactSection';
import { Divider } from '../components/ui';

export default function HomePage() {
  return (
    <>
      <HeroSection />
      <Divider />
      <AboutSection />
      <Divider />
      <PortfolioSection />
      <Divider />
      <TestimonialsSection />
      <Divider />
      <BlogSection />
      <Divider />
      <FAQSection />
      <Divider />
      <ContactSection />
    </>
  );
}
